import styles from './AboutPage.module.scss';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import aboutImg from 'assets/images/aboutImg.png';
import { ProfileBar } from '../components/profile-bar/ProfileBar';
import Label from '../../constants/Label';
import { loginActions, commonActions } from '../../stores/_actions';

function AboutPage() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };

  const aboutUsData = useSelector((state) => state.aboutUs?.data);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loginActions.aboutUs(payload));
    dispatch(commonActions.getCustDetailsByCode(payload));
  }, []);
  const userProfile = useSelector((state) => state.getCustDetails.data);
  let url = '';
  const aboutUsItem =
    aboutUsData &&
    aboutUsData.map((items, index) => {
      if (items.AboutUs.indexOf('yout') !== -1) {
        return (
          <iframe
            width="100%"
            height="350"
            src="https://www.youtube.com/embed/qZ--M9tFBsY"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        );
      }
      if (index === 0) {
        url = items.AboutUs;
        return;
      } else if (index === 1) {
        return;
      }
      return <p key={index}>{items.AboutUs}</p>;
    });

  function visitWebsite() {
    window.open(url);
  }

  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            {/* <div className={styles.spinner}></div> */}
            <div className={styles.pageLeft}>
              {/* <h1>{Label.AboutUS.heading}</h1> */}
              <div className={styles.pageLeft__aboutUs}>
                {/* <img src={aboutImg} alt="" /> */}
                <button className={styles.visit_website_btn} onClick={visitWebsite}>
                  Visit Website
                </button>
                <h3>{Label.AboutUS.heading}</h3>
                {aboutUsItem ? aboutUsItem : <div className={styles.spinner}></div>}
              </div>
            </div>
            <div className={styles.pageRight}>&nbsp;</div>
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { AboutPage };
